<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      &nbsp;&nbsp;{{displayName}} &nbsp;<i class="icon-user"></i> &nbsp;
    </template>\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>{{email}}</strong></b-dropdown-header>
      <b-dropdown-item @click="logout"><i class="fa fa-lock"/> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  computed: {
    displayName() {
      return this.$store.getters.user ? this.$store.getters.user.displayName : 'Login'
    },
    email() {
      return this.$store.getters.user ? this.$store.getters.user.email : 'No Login'
    }
  },
  methods: {
    logout: function() {
      console.log('logout')
      delete localStorage.userInfo
      this.$router.push('/pages/login')
    }
  }
}
</script>
